import styled from "styled-components";
import { ContainerTabType } from "./Types";

export const Container = styled.div`
	width: auto;
	max-width: 500px;
	height: 100vh;
	background-color: #ffffff;
`;

export const ContainerTab = styled.div<ContainerTabType>`
	padding-top: 15px;
	padding-bottom: 15px;
	padding-left: 15px;
	padding-right: 15px;
	width: 33.333%;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	background-color: ${(props) => (props.isChoice ? "#FFFFFF" : "#F2F3F7")};
	font-size: 17px;
	line-height: 24px;
	color: ${(props) => (props.isChoice ? "#2E3192" : "#5B5D6B")};
	@media (max-width: 768px) {
		padding-top: 20px;
		padding-bottom: 20px;
		padding-left: 10px;
		padding-right: 10px;
		font-size: 14px;
	}
	@media (max-width: 640px) {
		padding-top: 20px;
		padding-bottom: 20px;
		padding-left: 10px;
		padding-right: 10px;
		font-size: 8px;
	}
	:hover {
		cursor: pointer;
	}
`;

export const ContainerItem = styled.div`
	padding-left: 10px;
	padding-right: 15px;
	padding-top: 10px;
	padding-bottom: 20px;
	border-color: #d9d9d9;
	border-bottom-width: 1px;
	display: flex;
	flex-direction: row;
`;

export const ImageItem = styled.img`
	width: 66px;
	height: 66px;
	border-radius: 9999px;
	margin-right: 23px;
`;

export const InfoItem = styled.div`
	display: flex;
	justify-content: space-around;
	flex-direction: column;
`;

export const TitleItem = styled.div`
	color: #2d3436;
	font-size: 20px;
	line-height: 24px;
	@media (max-width: 768px) {
		font-size: 14px;
	}
`;

export const DateTimeItem = styled.div`
	color: #5b5d6b;
	font-size: 18px;
	line-height: 24px;
	@media (max-width: 768px) {
		font-size: 12px;
	}
`;
